export const CLIENT_CONFIGURATION_FINISH_LOADING_ONE =
    "CLIENT_CONFIGURATION_FINISH_LOADING_ONE";
export const CLIENT_CONFIGURATION_SHOW_SET_ERROR =
    "CLIENT_CONFIGURATION_SHOW_SET_ERROR";
export const CLIENT_CONFIGURATION_SHOW_SET_RETRIEVED_ONE =
    "CLIENT_CONFIGURATION_SHOW_SET_RETRIEVED_ONE";
export const CLIENT_CONFIGURATION_START_LOADING_ONE =
    "CLIENT_CONFIGURATION_START_LOADING_ONE";
